import React, { useEffect, useState } from "react";
import { Modal } from "antd";

import LeadForm from "./LeadForm";

const CreateNewLead = ({ openModal, setShowAddLeadModal }) => {
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShowModal(openModal);
  }, [openModal]);

  const closeModal = () => {
    setShowModal(false);
    setShowAddLeadModal(false);
  };

  return (
    <Modal
      title={
        <div
          className="heading18px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          Create New Lead
        </div>
      }
      width="650px"
      open={showModal}
      onCancel={closeModal}
      className="delete-popup"
      confirmLoading={loading}
      footer={false}
    >
      <div className="mt20">
        <LeadForm isNewLead setLoading={setLoading} closeModal={closeModal} />
      </div>
    </Modal>
  );
};

export default CreateNewLead;
